import dynamic from "next/dynamic";
import React from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend dayjs with the plugin
dayjs.extend(customParseFormat);


export const calculationFormatDateInput = (
  input: string,
  cursorPos: number
): string => {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, "");

  // Limit to 8 digits (ddmmyyyy)
  const limitedDigits = digits.slice(0, 8);

  let formatted = "";

  // Add digits with slashes at appropriate positions
  for (let i = 0; i < limitedDigits.length; i++) {
    // Add slash after day (position 2) and month (position 4)
    if (i === 2 || i === 4) {
      formatted += "/";
    }
    formatted += limitedDigits[i];
  }

  return formatted;
};

export const calculationParseAndValidateDate = (
  formattedDate: string
): Date | null => {
  if (!formattedDate.includes("/")) return null;

  // Parse the date in local timezone to avoid timezone issues
  const date = dayjs(formattedDate, "DD/MM/YYYY", true).hour(12);
  const currentYear = dayjs().year();
  const today = dayjs().hour(12).startOf("day");

  // Validate date existence and year range
  if (!date.isValid() || date.year() < 1900 || date.year() > currentYear) {
    return null;
  }

  // Check if date is in the future
  if (date.isAfter(today)) {
    return null;
  }

  // Return the date in local timezone
  return date.toDate();
};

export const calculationParseDateInputNew = (input: string): Date => {
  const parsedDate = calculationParseAndValidateDate(input);
  return parsedDate || new Date(NaN); // Invalid Date
};
